var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('STable',{ref:"tableref",attrs:{"url":_vm.url,"selection":false,"columns":_vm.columns,"handle":_vm.handle,"handles":_vm.handles,"query":_vm.query,"toolbar":_vm.toolbar,"label-width":"100px","cnames":"电桩状态"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14adcba4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plantManagement/InterconnectedStation.vue
// module id = null
// module chunks = 